import React from "react";
import { APPLY_FLOW_STEPS } from "./ApplyFlowStepper";
import { FiCheckCircle, FiFileText, FiShield, FiUser } from "react-icons/fi";

const STEP_COPY = {
  1: {
    headline: "Verify identity",
    sub: "Step 1 of 3",
  },
  2: {
    headline: "Confirm contact",
    sub: "Step 2 of 3",
  },
  3: {
    headline: "Submit profile",
    sub: "Step 3 of 3",
  },
};

const STEP_ICONS = {
  1: FiShield,
  2: FiUser,
  3: FiFileText,
};

const ApplyFlowSidebar1 = ({ currentStep }) => {
  const copy = STEP_COPY[currentStep] || STEP_COPY[1];
  const totalSteps = APPLY_FLOW_STEPS.length;
  const completedSteps = Math.max(0, currentStep - 1);
  const progressValue = Math.round((completedSteps / totalSteps) * 100);

  return (
    <div className="apply-now1-sidepanel">
      <div className="apply-now1-sidepanel__card">
        <div className="apply-now1-sidepanel__head">
          <div className="apply-now1-sidepanel__stepchip" aria-hidden="true">
            {currentStep}/{totalSteps}
          </div>
          <div className="apply-now1-sidepanel__copy">
            <span className="apply-now1-sidepanel__eyebrow">Application Journey</span>
            <h1>{copy.headline}</h1>
            <p>{copy.sub}</p>
          </div>
        </div>

        <div className="apply-now1-sidepanel__progress">
          <div className="apply-now1-sidepanel__progress-meta">
            <span>Progress</span>
            <strong>{progressValue}%</strong>
          </div>
          <div className="apply-now1-sidepanel__progress-bar">
            <span style={{ width: `${progressValue}%` }} />
          </div>
        </div>
      </div>

      <nav className="apply-now1-sidepanel__track" aria-label="Progress">
        {APPLY_FLOW_STEPS.map((step) => {
          const done = currentStep > step.id;
          const active = currentStep === step.id;
          const Icon = STEP_ICONS[step.id];
          return (
            <div
              key={step.id}
              className={`apply-now1-sidepanel__item ${active ? "is-active" : ""} ${done ? "is-done" : ""}`}
            >
              <div className="apply-now1-sidepanel__text">
                <em>0{step.id}</em>
                <strong>{step.title}</strong>
                <small>{step.subtitle}</small>
              </div>
              <span className="apply-now1-sidepanel__icon">
                {done ? <FiCheckCircle /> : <Icon />}
              </span>
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export default ApplyFlowSidebar1;
